import React from 'react';
import ComingSoonContainer from '@src/containers/ComingSoon';

const ComingSoon = () => <ComingSoonContainer />;

export default ComingSoon;
